import { ClienteModel } from "../cliente/cliente.model";
import { ArmazemModel } from "./armazem.model";
import { TipoEnderecoModel } from "./tipoendereco.model";

export class EnderecoModel {
    id: number;
    cep: String;
    logradouro: String;
    numero: String;
    complemento: String;
    uf: String;
    bairro: String;
    cidade: String;
    telefone1: String;
    telefone2: String;
    ativo: boolean;
    tipoEndereco: TipoEnderecoModel;
    armazem: ArmazemModel;
    cliente: ClienteModel;
}


// WEBPACK FOOTER //
// /app/src/app/model/endereco/endereco.model.ts